import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app.component";
import { ChartsModule, ThemeService } from "ng2-charts";

import {
  GlobalsService,
  AuthInterceptor,
  ToolboxService,
} from "./shared/services";
import { SharedModule } from "./shared/shared.module";
import { LoadingService, LoadingGlobalService } from "./shared/components";
import { ProcessService } from "./shared/services/process";
import { FormsModule } from "@angular/forms";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { ExploreService } from "./shared/services/explore.service";
/* import {LoaderInterceptor} from './shared/services/loader.interceptor'; */
import { DocumentsCrudService } from "./shared/services/documents-crud.service";
import { DataServiceService } from "./shared/services/data-service.service";
import { PopoverModule } from "ngx-bootstrap/popover";
import { AlertModule } from "ngx-bootstrap/alert";

import { NgBootstrapDatetimeAngularModule } from "ng-bootstrap-datetime-angular";
import {
  MomentDateTimeAdapter,
  OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS,
} from "ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export const MY_MOMENT_FORMATS = {
  fullPickerInput: "DD/MM/YYYY HH:mm:ss",
  parseInput: "DD/MM/YYYY HH:mm:ss",
  datePickerInput: "DD/MM/YYYY HH:mm:ss",
  timePickerInput: "LT",
  monthYearLabel: "MMM YYYY",
  dateA11yLabel: "LL",
  monthYearA11yLabel: "MMMM YYYY",
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    NgBootstrapDatetimeAngularModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ChartsModule,
    AlertModule.forRoot(),
    PopoverModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 20000,
    }),
    LoadingBarRouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    ThemeService,
    GlobalsService,
    ToolboxService,
    NgbActiveModal,
    LoadingService /* {provide:HTTP_INTERCEPTORS,useClass: LoaderInterceptor, multi: true }, */,
    LoadingGlobalService,
    ExploreService,
    ProcessService,
    DocumentsCrudService,
    DataServiceService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
